import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { DebugDefaultRouteMap, DefaultRouteMap } from '../components/live-event/hooks/use-route-map';
import { PATHNAMES } from "./admin-routing-utils";

// The navbar renders in the admin editor as well as the live event, and useCurrentPageState
// compares the result of this hook against these admin patterns - so they have to be
// matchable here or every editor nav state silently falls back to the raw pathname.
// Ordered most-specific first; PATHNAMES.Event.Event is the most general and goes last.
const adminPatterns = [
	PATHNAMES.Event.HomePath,
	PATHNAMES.Event.SessionsPath,
	PATHNAMES.Event.LeaderboardPath,
	PATHNAMES.Event.Directory,
	PATHNAMES.Event.SocialProfile,
	PATHNAMES.Event.Landing,
	PATHNAMES.Session.Session,
	PATHNAMES.Event.Event,
];

// Both live URL shapes are reachable in every environment - the /event/:uuid route in App.tsx
// is not gated on the build stage - so match against both maps rather than picking one from
// VITE_STAGE. Admin patterns are checked first: they all start with a literal /admin, so no
// live URL can match them, while the /:eventName/... patterns are greedy enough to match an
// admin url by accident.
const routePatterns = [
	...adminPatterns,
	...Object.values(DebugDefaultRouteMap),
	...Object.values(DefaultRouteMap)
];

export const useMatchedPath = (): string => {
	const { pathname } = useLocation();

	return useMemo(() => {
		for (const pattern of routePatterns) {
			if (matchPath({ path: pattern, end: true }, pathname)) {
				return pattern;
			}
		}

		return pathname;
	}, [pathname]);
};
